import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';

export const createApplicationContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    microfrontendsRegistry: registry(),
    telemetry: getTelemetry(),
  };
};
